import React, { useCallback } from 'react'
import cx from 'classnames'

const AutocompleteOption = React.memo(({ index, style, data }) => {
  const { items, currentFocusIndex, renderItem, onClick } = data
  const value = items[index]
  const handleOnClick = useCallback(() => {
    onClick(value)
  }, [onClick, value])

  return (
    <div
      style={style}
      onClick={handleOnClick}
      className={cx('option', 'bx--list-box__menu-item', {
        current: currentFocusIndex === index
      })}
    >
      <div className='bx--list-box__menu-item__option'>{renderItem(value)}</div>
    </div>
  )
})

export default AutocompleteOption
